// ============================================
// СЛАЙДЕР ОТЗЫВОВ
// ============================================
// Код слайдеров отзывов вынесен из script.js
// Включает: десктопные слайдеры, мобильные карусели, кнопки "Развернуть"

// ============================================
// ФИЛЬТРАЦИЯ ОТЗЫВОВ РОДИТЕЛЕЙ ПО КАМПУСУ
// ============================================
(function() {
  function filterParentReviewsByCampus(campusSlug) {
    const slides = document.getElementById('parentReviewsSlides');
    if (!slides) return;
    const cards = slides.querySelectorAll('.block19_review_card:not(.block19-parent-review-card-clone)');
    cards.forEach(card => {
      const cardCampus = card.getAttribute('data-campus');
      const match = cardCampus === campusSlug || cardCampus === 'all';
      card.style.display = match ? '' : 'none';
    });
    // Сбрасываем навигацию после смены кампуса
    if (typeof window.updateParentReviewsNavigation === 'function') {
      setTimeout(window.updateParentReviewsNavigation, 50);
    }
  }
  window.filterParentReviewsByCampus = filterParentReviewsByCampus;
})();

// ============================================
// КНОПКА "РАЗВЕРНУТЬ" В ОТЗЫВАХ
// ============================================
(function() {
  if (document.body.classList.contains('middle-high-page') && !document.querySelector('[data-landing-staff-js]')) return;
  // Функция для проверки, нужно ли показывать кнопку "развернуть"
  function checkIfTextOverflows(reviewCard) {
    const reviewText = reviewCard.querySelector('.review_text');
    if (!reviewText) return false;
    
    // Проверяем, обрезан ли текст (scrollHeight > clientHeight)
    return reviewText.scrollHeight > reviewText.clientHeight;
  }
  
  // Функция для обновления видимости кнопки
  function updateButtonVisibility(button) {
    const reviewCard = button.closest('.review_card');
    if (!reviewCard) return;
    
    // Если карточка развернута, всегда показываем кнопку
    if (reviewCard.classList.contains('expanded')) {
      button.style.display = 'block';
      return;
    }
    
    // Если текст не обрезан, скрываем кнопку
    if (!checkIfTextOverflows(reviewCard)) {
      button.style.display = 'none';
    } else {
      button.style.display = 'block';
    }
  }
  
  // Функция для обновления текста кнопки с учетом текущего языка
  function updateButtonText(button) {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    if (typeof translations !== 'undefined' && translations[lang]) {
      const t = translations[lang];
      const reviewCard = button.closest('.review_card');
      if (reviewCard && reviewCard.classList.contains('expanded')) {
        button.textContent = t.review_collapse;
      } else {
        button.textContent = t.review_expand;
      }
    }
  }
  
  // Инициализация кнопок
  function initExpandButtons() {
    const expandButtons = document.querySelectorAll('.review_expand');
    
    expandButtons.forEach(button => {
      // Проверяем видимость кнопки при загрузке
      updateButtonVisibility(button);
      
      // Обновляем текст кнопки при загрузке
      updateButtonText(button);
      
      button.addEventListener('click', () => {
        const reviewCard = button.closest('.review_card');
        
        if (reviewCard.classList.contains('expanded')) {
          // Свернуть
          reviewCard.classList.remove('expanded');
        } else {
          // Развернуть
          reviewCard.classList.add('expanded');
        }
        
        // Обновляем видимость и текст кнопки
        updateButtonVisibility(button);
        updateButtonText(button);
      });
    });
  }
  
  // Инициализация при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initExpandButtons, 100);
    });
  } else {
    setTimeout(initExpandButtons, 100);
  }
  
  // Обновление при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const expandButtons = document.querySelectorAll('.review_expand');
      expandButtons.forEach(button => {
        updateButtonVisibility(button);
      });
    }, 100);
  });
})();

// ============================================
// СЛАЙДЕР ОТЗЫВОВ (BLOCK14)
// ============================================
(function() {
  if (document.body.classList.contains('middle-high-page') && !document.querySelector('[data-landing-staff-js]')) return;
  function initReviewsSlider() {
    const reviewsSlides = document.getElementById('reviewsSlides');
    const prevBtn = document.getElementById('reviewsPrev');
    const nextBtn = document.getElementById('reviewsNext');
    
    if (!reviewsSlides || !prevBtn || !nextBtn) return;
    
    const cards = reviewsSlides.querySelectorAll('.review_card');
    let currentPage = 0;
  
  // Функция для определения количества карточек, которые полностью помещаются в блок по ширине
  function getVisibleCardsCount() {
    if (cards.length === 0) return 0;
    
    const containerRect = reviewsSlides.getBoundingClientRect();
    const containerWidth = containerRect.width;
    let visibleCount = 0;
    let totalWidth = 0;
    const gap = 13; // gap между карточками из CSS
    
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      const cardRect = card.getBoundingClientRect();
      const cardWidth = cardRect.width;
      
      // Учитываем gap только между карточками (не перед первой)
      const widthWithGap = i > 0 ? cardWidth + gap : cardWidth;
      
      if (totalWidth + widthWithGap <= containerWidth) {
        totalWidth += widthWithGap;
        visibleCount++;
      } else {
        break;
      }
    }
    
    return visibleCount;
  }
  
  // Функция для вычисления максимального количества нажатий направо
  function getMaxNextClicks() {
    const visibleCount = getVisibleCardsCount();
    return Math.max(0, cards.length - visibleCount);
  }
  
  let maxNextClicks = getMaxNextClicks(); // Максимальное количество нажатий направо
  
  // Функция для определения количества карточек для прокрутки
  function getCardsToScroll() {
    return 1;
  }
  
  // Функция для пересчета totalPages
  function getTotalPages() {
    const cardsToScroll = getCardsToScroll();
    return Math.ceil(cards.length / cardsToScroll);
  }
  
  function isLastCardFullyVisible() {
    if (cards.length === 0) return true;
    const lastCard = cards[cards.length - 1];
    const containerRect = reviewsSlides.getBoundingClientRect();
    const lastCardRect = lastCard.getBoundingClientRect();
    return lastCardRect.right <= containerRect.right;
  }
  
  function scrollToPage(page) {
    const cardsToScroll = getCardsToScroll();
    const totalPages = getTotalPages();
    
    if (page < 0) page = 0;
    
    // Если пытаемся перейти на страницу после последней, проверяем видимость последнего элемента
    if (page >= totalPages) {
      if (!isLastCardFullyVisible()) {
        // Прокручиваем до конца, чтобы показать последний элемент полностью
        const lastCard = cards[cards.length - 1];
        const containerRect = reviewsSlides.getBoundingClientRect();
        const lastCardRect = lastCard.getBoundingClientRect();
        const scrollLeft = reviewsSlides.scrollLeft + (lastCardRect.right - containerRect.right) + 20;
        
        reviewsSlides.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
        currentPage = totalPages - 1;
      } else {
        page = totalPages - 1;
        currentPage = page;
      }
    } else {
      currentPage = page;
      const index = page * cardsToScroll;
      const card = cards[index];
      
      if (card) {
        const containerRect = reviewsSlides.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const scrollLeft = reviewsSlides.scrollLeft + (cardRect.left - containerRect.left) - 10;
        
        reviewsSlides.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }
    
    // Обновляем кнопки после завершения прокрутки
    setTimeout(updateButtons, 300);
  }
  
  prevBtn.addEventListener('click', () => {
    scrollToPage(currentPage - 1);
  });
  
  nextBtn.addEventListener('click', () => {
    // Проверяем, не превысили ли максимальное количество нажатий направо
    if (currentPage < maxNextClicks) {
      scrollToPage(currentPage + 1);
    }
  });
  
  function updateButtons() {
    const totalPages = getTotalPages();
    prevBtn.style.opacity = currentPage > 0 ? '1' : '0.5';
    prevBtn.style.cursor = currentPage > 0 ? 'pointer' : 'not-allowed';
    
    // Кнопка направо активна только если не превышено максимальное количество нажатий
    const canClickNext = currentPage < maxNextClicks;
    nextBtn.style.opacity = canClickNext ? '1' : '0.5';
    nextBtn.style.cursor = canClickNext ? 'pointer' : 'not-allowed';
  }
  
  // Пересчитываем при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Пересчитываем maxNextClicks при изменении размера
      maxNextClicks = getMaxNextClicks();
      currentPage = Math.min(currentPage, getTotalPages() - 1);
      updateButtons();
    }, 100);
  });
  
  
    // Убеждаемся, что клики работают на карточках
    cards.forEach(card => {
      card.style.pointerEvents = 'auto';
      card.style.cursor = 'pointer';
    });
    
    updateButtons();
  }
  
  // Инициализируем слайдер при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSlider);
  } else {
    initReviewsSlider();
  }
})();

// ---------- Слайдер отзывов родителей (block19_reviews) ----------
(function() {
  function initParentReviewsSlider() {
    const parentReviewsSlides = document.getElementById('parentReviewsSlides');
    const parentReviewsPrevBtn = document.getElementById('parentReviewsPrev');
    const parentReviewsNextBtn = document.getElementById('parentReviewsNext');
    
    if (!parentReviewsSlides || !parentReviewsPrevBtn || !parentReviewsNextBtn) return;
  
  let currentPage = 0;

  // Динамически получаем только видимые карточки (без клонов, без скрытых кампусов)
  function getParentReviewCards() {
    return Array.from(parentReviewsSlides.querySelectorAll('.block19_review_card')).filter(
      card => !card.classList.contains('block19-parent-review-card-clone') &&
              window.getComputedStyle(card).display !== 'none'
    );
  }
  
  // Количество карточек, которые полностью помещаются в контейнер по ширине
  function getVisibleCardsCount() {
    const cards = getParentReviewCards();
    if (cards.length === 0) return 0;
    
    const containerRect = parentReviewsSlides.getBoundingClientRect();
    const containerWidth = containerRect.width;
    if (containerWidth === 0) return 0;
    let visibleCount = 0;
    let totalWidth = 0;
    const gap = 15;
    
    for (let i = 0; i < cards.length; i++) {
      const cardWidth = cards[i].getBoundingClientRect().width;
      if (cardWidth === 0) continue; // пропускаем скрытые
      const widthWithGap = i > 0 ? cardWidth + gap : cardWidth;
      if (totalWidth + widthWithGap <= containerWidth) {
        totalWidth += widthWithGap;
        visibleCount++;
      } else {
        break;
      }
    }
    
    return visibleCount;
  }
  
  function getMaxNextClicks() {
    const cards = getParentReviewCards();
    return Math.max(0, cards.length - getVisibleCardsCount());
  }
  
  function getTotalPages() {
    return getParentReviewCards().length;
  }
  
  function isLastCardFullyVisible() {
    const cards = getParentReviewCards();
    if (cards.length === 0) return true;
    const lastCard = cards[cards.length - 1];
    const containerRect = parentReviewsSlides.getBoundingClientRect();
    return lastCard.getBoundingClientRect().right <= containerRect.right;
  }
  
  function scrollToPage(page) {
    const cards = getParentReviewCards();
    const totalPages = cards.length;
    
    if (page < 0) page = 0;
    
    if (page >= totalPages) {
      if (!isLastCardFullyVisible()) {
        const lastCard = cards[cards.length - 1];
        const containerRect = parentReviewsSlides.getBoundingClientRect();
        const lastCardRect = lastCard.getBoundingClientRect();
        const scrollLeft = parentReviewsSlides.scrollLeft + (lastCardRect.right - containerRect.right) + 20;
        parentReviewsSlides.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        currentPage = totalPages - 1;
      } else {
        currentPage = totalPages - 1;
      }
    } else {
      currentPage = page;
      const card = cards[page];
      if (card) {
        const containerRect = parentReviewsSlides.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const scrollLeft = parentReviewsSlides.scrollLeft + (cardRect.left - containerRect.left) - 20;
        parentReviewsSlides.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }
    
    setTimeout(updateButtons, 300);
  }
  
  parentReviewsPrevBtn.addEventListener('click', () => {
    scrollToPage(currentPage - 1);
  });
  
  parentReviewsNextBtn.addEventListener('click', () => {
    const maxClicks = getMaxNextClicks();
    if (currentPage < maxClicks) {
      scrollToPage(currentPage + 1);
    }
  });
  
  function updateButtons() {
    const maxClicks = getMaxNextClicks();
    parentReviewsPrevBtn.style.opacity = currentPage > 0 ? '1' : '0.5';
    parentReviewsPrevBtn.style.cursor = currentPage > 0 ? 'pointer' : 'not-allowed';
    const canClickNext = currentPage < maxClicks;
    parentReviewsNextBtn.style.opacity = canClickNext ? '1' : '0.5';
    parentReviewsNextBtn.style.cursor = canClickNext ? 'pointer' : 'not-allowed';
  }
  
  // Синхронизируем currentPage при ручной прокрутке
  let scrollSyncTimeout;
  parentReviewsSlides.addEventListener('scroll', () => {
    clearTimeout(scrollSyncTimeout);
    scrollSyncTimeout = setTimeout(() => {
      const cards = getParentReviewCards();
      const containerLeft = parentReviewsSlides.getBoundingClientRect().left;
      let closestPage = 0;
      let minDistance = Infinity;
      for (let i = 0; i < cards.length; i++) {
        const distance = Math.abs(cards[i].getBoundingClientRect().left - containerLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestPage = i;
        }
      }
      currentPage = closestPage;
      updateButtons();
    }, 100);
  });

  // Пересчитываем при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      currentPage = Math.min(currentPage, getTotalPages() - 1);
      updateButtons();
    }, 100);
  });

  // Экспортируем для обновления при смене кампуса
  window.updateParentReviewsNavigation = function() {
    currentPage = 0;
    parentReviewsSlides.scrollTo({ left: 0, behavior: 'smooth' });
    setTimeout(updateButtons, 300);
  };

    updateButtons();
  }
  
  // Инициализируем слайдер при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParentReviewsSlider);
  } else {
    initParentReviewsSlider();
  }
})();

// ---------- Кнопка "Развернуть" для отзывов родителей и учеников ----------
(function() {
  function checkIfTextOverflows(reviewCard) {
    const reviewText = reviewCard.querySelector('.block19_review_text');
    if (!reviewText) return false;
    
    // Проверяем, обрезан ли текст (scrollHeight > clientHeight)
    return reviewText.scrollHeight > reviewText.clientHeight;
  }
  
  // Функция для обновления видимости кнопки (всегда показываем кнопку в block19)
  function updateButtonVisibility(button) {
    const reviewCard = button.closest('.block19_review_card');
    if (!reviewCard) return;
    button.style.display = '';
  }
  
  function updateButtonText(button) {
    const card = button.closest('.block19_review_card');
    if (card) {
      const isExpanded = card.classList.contains('expanded');
      const currentLang = localStorage.getItem('siteLanguage') || 'ru';
      const translations = window.translations || {};
      const t = translations[currentLang] || {};
      
      if (isExpanded) {
        button.textContent = t.block19_review_collapse || 'Свернуть';
      } else {
        button.textContent = t.block19_review_expand || 'Развернуть';
      }
    }
  }
  
  // Функция для синхронизации высоты неразвернутых карточек (универсальная)
  function syncCollapsedCardsHeight(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    const allCards = container.querySelectorAll('.block19_review_card');
    const collapsedCards = Array.from(allCards).filter(card => !card.classList.contains('expanded'));
    
    if (collapsedCards.length === 0) return;
    
    // Сбрасываем высоту всех неразвернутых карточек, чтобы найти естественную высоту
    collapsedCards.forEach(card => {
      card.style.height = 'auto';
    });
    
    // Находим максимальную высоту среди неразвернутых карточек
    let maxHeight = 0;
    collapsedCards.forEach(card => {
      const cardHeight = card.offsetHeight;
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });
    
    // Устанавливаем одинаковую высоту для всех неразвернутых карточек
    if (maxHeight > 0) {
      collapsedCards.forEach(card => {
        card.style.height = maxHeight + 'px';
      });
    }
  }
  
  // Функция для синхронизации высоты неразвернутых карточек родителей
  function syncParentCollapsedCardsHeight() {
    syncCollapsedCardsHeight('parentReviewsSlides');
  }
  
  // Функция для синхронизации высоты неразвернутых карточек учеников
  function syncStudentCollapsedCardsHeight() {
    syncCollapsedCardsHeight('studentReviewsSlides');
  }
  
  // Инициализация кнопок для конкретного контейнера
  function initExpandButtonsForContainer(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;
    
    const expandButtons = container.querySelectorAll('.block19_review_expand');
    
    expandButtons.forEach(button => {
      // Проверяем, не был ли уже добавлен обработчик
      if (button.dataset.expandInitialized === 'true') {
        // Обновляем только видимость и текст, но не добавляем обработчик повторно
        updateButtonVisibility(button);
        updateButtonText(button);
        return;
      }
      
      // Отмечаем, что обработчик был добавлен
      button.dataset.expandInitialized = 'true';
      
      // Проверяем видимость кнопки при загрузке
      updateButtonVisibility(button);
      
      // Обновляем текст кнопки при загрузке
      updateButtonText(button);
      
      button.addEventListener('click', (e) => {
        e.stopPropagation(); // Останавливаем всплытие события, чтобы не срабатывал клик на карточке
        e.preventDefault(); // Предотвращаем стандартное поведение
        
        // Находим карточку, к которой относится эта кнопка
        const card = button.closest('.block19_review_card');
        if (!card) return;
        
        // Работаем только с этой конкретной карточкой
        // Сначала убираем класс expanded у всех других карточек в этом контейнере
        const allCards = container.querySelectorAll('.block19_review_card');
        allCards.forEach(otherCard => {
          if (otherCard !== card) {
            otherCard.classList.remove('expanded');
            otherCard.style.height = ''; // Сбрасываем высоту других карточек
            // Обновляем текст кнопок других карточек
            const otherButton = otherCard.querySelector('.block19_review_expand');
            if (otherButton) {
              updateButtonText(otherButton);
            }
          }
        });
        
        // Теперь переключаем состояние только этой карточки
        const isExpanded = card.classList.contains('expanded');
        
        if (isExpanded) {
          card.classList.remove('expanded');
          card.style.height = ''; // Сбрасываем высоту при сворачивании
          card.style.removeProperty('height'); // Удаляем inline стиль
        } else {
          card.classList.add('expanded');
          // Устанавливаем height: auto с !important через CSS класс, но также устанавливаем inline для надежности
          card.style.height = 'auto';
          // Принудительно пересчитываем высоту
          card.style.removeProperty('max-height');
        }
        
        // Обновляем видимость и текст только этой кнопки
        updateButtonVisibility(button);
        updateButtonText(button);
        
        // Синхронизируем высоту неразвернутых карточек для этого контейнера
        setTimeout(() => {
          syncCollapsedCardsHeight(containerId);
        }, 10);
      });
    });
    
    // Синхронизируем высоту при инициализации
    setTimeout(() => {
      syncCollapsedCardsHeight(containerId);
    }, 100);
  }
  
  // Инициализация кнопок для обоих разделов
  function initExpandButtons() {
    initExpandButtonsForContainer('parentReviewsSlides');
    initExpandButtonsForContainer('studentReviewsSlides');
  }
  
  // Инициализация при загрузке DOM с повторной проверкой
  function initWithDelay() {
    setTimeout(() => {
      initExpandButtons();
      // Повторная инициализация через 500ms на случай, если отзывы загружаются динамически
      setTimeout(initExpandButtons, 500);
    }, 200);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithDelay);
  } else {
    initWithDelay();
  }
  
  // Обновление при изменении размера окна
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const parentReviewsContainer = document.getElementById('parentReviewsSlides');
      if (parentReviewsContainer) {
        const expandButtons = parentReviewsContainer.querySelectorAll('.block19_review_expand');
        expandButtons.forEach(button => {
          updateButtonVisibility(button);
        });
        syncParentCollapsedCardsHeight();
      }
      
      const studentReviewsContainer = document.getElementById('studentReviewsSlides');
      if (studentReviewsContainer) {
        const expandButtons = studentReviewsContainer.querySelectorAll('.block19_review_expand');
        expandButtons.forEach(button => {
          updateButtonVisibility(button);
        });
        syncStudentCollapsedCardsHeight();
      }
    }, 100);
  });
  
  // Обновление при изменении языка
  const originalApplyLanguage = window.applyLanguage;
  if (originalApplyLanguage) {
    window.applyLanguage = function(...args) {
      originalApplyLanguage.apply(this, args);
      setTimeout(() => {
        const parentReviewsContainer = document.getElementById('parentReviewsSlides');
        if (parentReviewsContainer) {
          const expandButtons = parentReviewsContainer.querySelectorAll('.block19_review_expand');
          expandButtons.forEach(button => {
            updateButtonText(button);
          });
          syncParentCollapsedCardsHeight();
        }
        
        const studentReviewsContainer = document.getElementById('studentReviewsSlides');
        if (studentReviewsContainer) {
          const expandButtons = studentReviewsContainer.querySelectorAll('.block19_review_expand');
          expandButtons.forEach(button => {
            updateButtonText(button);
          });
          syncStudentCollapsedCardsHeight();
        }
      }, 100);
    };
  }
})();

// ---------- Слайдер отзывов учеников (block19_students_reviews) ----------
(function() {
  function initStudentReviewsSlider() {
    const studentReviewsSlides = document.getElementById('studentReviewsSlides');
    const studentReviewsPrevBtn = document.getElementById('studentReviewsPrev');
    const studentReviewsNextBtn = document.getElementById('studentReviewsNext');
    
    if (!studentReviewsSlides || !studentReviewsPrevBtn || !studentReviewsNextBtn) return;

  let currentPage = 0;

  // Динамически получаем видимые карточки
  function getStudentReviewCards() {
    return Array.from(studentReviewsSlides.querySelectorAll('.block19_review_card')).filter(
      card => !card.classList.contains('block19-student-review-card-clone') &&
              window.getComputedStyle(card).display !== 'none'
    );
  }

  function getTotalPages() {
    return getStudentReviewCards().length;
  }

  function isLastCardFullyVisible() {
    const cards = getStudentReviewCards();
    if (cards.length === 0) return true;
    const lastCard = cards[cards.length - 1];
    const containerRect = studentReviewsSlides.getBoundingClientRect();
    return lastCard.getBoundingClientRect().right <= containerRect.right;
  }

  function scrollToPage(page) {
    const cards = getStudentReviewCards();
    const totalPages = cards.length;

    if (page < 0) page = 0;

    if (page >= totalPages) {
      if (!isLastCardFullyVisible()) {
        const lastCard = cards[cards.length - 1];
        const containerRect = studentReviewsSlides.getBoundingClientRect();
        const lastCardRect = lastCard.getBoundingClientRect();
        const scrollLeft = studentReviewsSlides.scrollLeft + (lastCardRect.right - containerRect.right) + 20;
        studentReviewsSlides.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        currentPage = totalPages - 1;
      } else {
        currentPage = totalPages - 1;
      }
    } else {
      currentPage = page;
      const card = cards[page];
      if (card) {
        const containerRect = studentReviewsSlides.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const scrollLeft = studentReviewsSlides.scrollLeft + (cardRect.left - containerRect.left) - 13;
        studentReviewsSlides.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }

    setTimeout(updateButtons, 300);
  }

  studentReviewsPrevBtn.addEventListener('click', () => {
    scrollToPage(currentPage - 1);
  });

  studentReviewsNextBtn.addEventListener('click', () => {
    scrollToPage(currentPage + 1);
  });

  function updateButtons() {
    const totalPages = getTotalPages();
    studentReviewsPrevBtn.style.opacity = currentPage > 0 ? '1' : '0.5';
    studentReviewsPrevBtn.style.cursor = currentPage > 0 ? 'pointer' : 'not-allowed';
    const canScrollNext = currentPage < totalPages - 1 || !isLastCardFullyVisible();
    studentReviewsNextBtn.style.opacity = canScrollNext ? '1' : '0.5';
    studentReviewsNextBtn.style.cursor = canScrollNext ? 'pointer' : 'not-allowed';
  }

  // Синхронизируем currentPage при ручной прокрутке
  let scrollSyncTimeout;
  studentReviewsSlides.addEventListener('scroll', () => {
    clearTimeout(scrollSyncTimeout);
    scrollSyncTimeout = setTimeout(() => {
      const cards = getStudentReviewCards();
      const containerLeft = studentReviewsSlides.getBoundingClientRect().left;
      let closestPage = 0;
      let minDistance = Infinity;
      for (let i = 0; i < cards.length; i++) {
        const distance = Math.abs(cards[i].getBoundingClientRect().left - containerLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestPage = i;
        }
      }
      currentPage = closestPage;
      updateButtons();
    }, 100);
  });

    // Пересчитываем при изменении размера окна
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        currentPage = Math.min(currentPage, getTotalPages() - 1);
        updateButtons();
      }, 100);
    });

    updateButtons();
  }
  
  // Инициализируем слайдер при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStudentReviewsSlider);
  } else {
    initStudentReviewsSlider();
  }
})();

// Бесконечная карусель для reviews_slider_wrapper при 768px (как slider_container)
// ============================================
(function() {
  if (document.body.classList.contains('middle-high-page') && !document.querySelector('[data-landing-staff-js]')) return;
  let reviewsSlides = null;
  let reviewsSliderWrapper = null;
  let currentReviewIndex = 0;
  let isTransitioning = false;
  let isAnimating = false;
  const reviewGap = 13;
  const reviewWidth = 280; // При 768px

  function getReviewWidth() {
    return reviewWidth;
  }

  function getReviewStep() {
    return getReviewWidth() + reviewGap;
  }

  function getTransitionDuration() {
    return '0.4s';
  }

  function getTransitionDurationMs() {
    return 400;
  }

  function getRealReviews() {
    if (!reviewsSlides) return [];
    return Array.from(reviewsSlides.querySelectorAll('.review_card:not(.review-card-clone)'));
  }

  function cloneReviews() {
    if (!reviewsSlides || window.innerWidth > 768) {
      if (reviewsSlides) {
        const oldClones = reviewsSlides.querySelectorAll('.review-card-clone');
        oldClones.forEach(clone => clone.remove());
      }
      return;
    }

    const realReviews = getRealReviews();
    if (realReviews.length === 0) return;

    const oldClones = reviewsSlides.querySelectorAll('.review-card-clone');
    oldClones.forEach(clone => clone.remove());

    const fragmentBefore = document.createDocumentFragment();
    realReviews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('review-card-clone');
      fragmentBefore.appendChild(clone);
    });
    reviewsSlides.insertBefore(fragmentBefore, realReviews[0]);

    realReviews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('review-card-clone');
      reviewsSlides.appendChild(clone);
    });
  }

  function isReviewsSectionVisible() {
    const section = document.getElementById('block14ReviewsSection');
    if (!section) return true;
    const style = window.getComputedStyle(section);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = section.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function updateReviewsSlider() {
    if (!reviewsSlides || window.innerWidth > 768) return;

    const realReviews = getRealReviews();
    if (realReviews.length === 0) return;

    // Не применять transform если блок скрыт — getBoundingClientRect вернёт неверные значения
    if (!isReviewsSectionVisible()) return;

    const containerRect = reviewsSliderWrapper ? reviewsSliderWrapper.getBoundingClientRect() : reviewsSlides.getBoundingClientRect();
    if (containerRect.width === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentReviewIndex < 0) {
      currentReviewIndex = 0;
    }
    if (currentReviewIndex >= realReviews.length) {
      currentReviewIndex = realReviews.length - 1;
    }

    const centerX = window.innerWidth / 2;
    const containerLeft = containerRect.left;

    const currentReviewWidth = getReviewWidth();
    const currentReviewStep = getReviewStep();
    const reviewCenterX = currentReviewWidth / 2;
    const realReviewIndexInDOM = realReviews.length + currentReviewIndex;
    const activeReviewLeftPosition = realReviewIndexInDOM * currentReviewStep;
    const activeReviewCenterPosition = activeReviewLeftPosition + reviewCenterX;

    const translateX = centerX - containerLeft - activeReviewCenterPosition;

    // Всегда устанавливаем transition для обычных переходов
    if (!isTransitioning) {
      reviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    reviewsSlides.style.transform = `translateX(${translateX}px)`;
  }

  function goToNextReview() {
    if (isAnimating || window.innerWidth > 768) return;

    const realReviews = getRealReviews();
    const realReviewsCount = realReviews.length;

    if (currentReviewIndex < realReviewsCount - 1) {
      isAnimating = true;
      currentReviewIndex++;
      updateReviewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const firstCloneIndex = realReviewsCount * 2;
      const currentReviewStep = getReviewStep();
      const containerRect = reviewsSliderWrapper ? reviewsSliderWrapper.getBoundingClientRect() : reviewsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentReviewWidth = getReviewWidth();
      const reviewCenterX = currentReviewWidth / 2;
      const activeReviewLeftPosition = firstCloneIndex * currentReviewStep;
      const activeReviewCenterPosition = activeReviewLeftPosition + reviewCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeReviewCenterPosition;

      reviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      reviewsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        reviewsSlides.style.transition = 'none';
        currentReviewIndex = 0;
        const realReviewsCount = realReviews.length;
        const currentReviewStep = getReviewStep();
        const containerRect = reviewsSliderWrapper ? reviewsSliderWrapper.getBoundingClientRect() : reviewsSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentReviewWidth = getReviewWidth();
        const reviewCenterX = currentReviewWidth / 2;
        const realReviewIndexInDOM = realReviewsCount + currentReviewIndex;
        const activeReviewLeftPosition = realReviewIndexInDOM * currentReviewStep;
        const activeReviewCenterPosition = activeReviewLeftPosition + reviewCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeReviewCenterPosition;
        reviewsSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            reviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function goToPrevReview() {
    if (isAnimating || window.innerWidth > 768) return;

    const realReviews = getRealReviews();
    const realReviewsCount = realReviews.length;

    if (currentReviewIndex > 0) {
      isAnimating = true;
      currentReviewIndex--;
      updateReviewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const lastCloneIndex = realReviewsCount - 1;
      const currentReviewStep = getReviewStep();
      const containerRect = reviewsSliderWrapper ? reviewsSliderWrapper.getBoundingClientRect() : reviewsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentReviewWidth = getReviewWidth();
      const reviewCenterX = currentReviewWidth / 2;
      const activeReviewLeftPosition = lastCloneIndex * currentReviewStep;
      const activeReviewCenterPosition = activeReviewLeftPosition + reviewCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeReviewCenterPosition;

      reviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      reviewsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        reviewsSlides.style.transition = 'none';
        currentReviewIndex = realReviewsCount - 1;
        const currentReviewStep = getReviewStep();
        const containerRect = reviewsSliderWrapper ? reviewsSliderWrapper.getBoundingClientRect() : reviewsSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentReviewWidth = getReviewWidth();
        const reviewCenterX = currentReviewWidth / 2;
        const realReviewIndexInDOM = realReviewsCount + currentReviewIndex;
        const activeReviewLeftPosition = realReviewIndexInDOM * currentReviewStep;
        const activeReviewCenterPosition = activeReviewLeftPosition + reviewCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeReviewCenterPosition;
        reviewsSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            reviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function getInitialTranslate() {
    const realReviews = getRealReviews();
    const containerRect = reviewsSliderWrapper ? reviewsSliderWrapper.getBoundingClientRect() : reviewsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;
    const centerX = window.innerWidth / 2;
    const currentReviewWidth = getReviewWidth();
    const currentReviewStep = getReviewStep();
    const reviewCenterX = currentReviewWidth / 2;
    const realReviewIndexInDOM = realReviews.length + currentReviewIndex;
    const activeReviewLeftPosition = realReviewIndexInDOM * currentReviewStep;
    const activeReviewCenterPosition = activeReviewLeftPosition + reviewCenterX;

    if (window.innerWidth <= 768 && currentReviewIndex === 0) {
      const viewportCenter = window.innerWidth / 2;
      return viewportCenter - containerLeft - activeReviewCenterPosition;
    } else {
      return centerX - containerLeft - activeReviewCenterPosition;
    }
  }

  function init() {
    if (window.innerWidth > 768) return;

    reviewsSlides = document.getElementById('reviewsSlides');
    if (!reviewsSlides) return;

    reviewsSliderWrapper = reviewsSlides.closest('.reviews_slider_wrapper') || reviewsSlides.parentElement;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    cloneReviews();
    currentReviewIndex = 0;

    // Инициализация позиции — дожидаемся layout, чтобы избежать неверного translateX на мобильных
    const initialReviews = reviewsSlides.querySelectorAll('.review_card');
    if (initialReviews.length > 0) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (isReviewsSectionVisible()) updateReviewsSlider();
        });
      });
    }

    reviewsSlides.addEventListener('mousedown', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      isDragging = true;
      startX = e.clientX;
      initialTranslate = getInitialTranslate();
      reviewsSlides.classList.add('dragging');
      e.preventDefault();
    });

    reviewsSlides.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      reviewsSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
    });

    reviewsSlides.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      reviewsSlides.classList.remove('dragging');

      const threshold = getReviewStep() / 6;
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevReview();
        } else {
          goToNextReview();
        }
      } else {
        updateReviewsSlider();
      }
      currentX = 0;
    });

    reviewsSlides.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        reviewsSlides.classList.remove('dragging');
        updateReviewsSlider();
        currentX = 0;
      }
    });

    reviewsSlides.addEventListener('touchstart', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchInitialTranslate = getInitialTranslate();
      reviewsSlides.classList.add('dragging');
    });

    reviewsSlides.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;

      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }

      reviewsSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
    });

    reviewsSlides.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      reviewsSlides.classList.remove('dragging');

      const threshold = getReviewStep() / 6;
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevReview();
        } else {
          goToNextReview();
        }
      } else {
        updateReviewsSlider();
      }
      touchCurrentX = 0;
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth <= 768) {
          cloneReviews();
          if (isReviewsSectionVisible()) updateReviewsSlider();
        } else {
          cloneReviews();
        }
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(init, 100);
    });
  } else {
    setTimeout(init, 100);
  }

  window.addEventListener('load', () => {
    if (window.innerWidth <= 768) {
      currentReviewIndex = 0;
      requestAnimationFrame(() => {
        if (isReviewsSectionVisible()) updateReviewsSlider();
      });
    }
  });

  // Для updateReviewsForCampus — переинициализация после смены кампуса
  window.updateReviewsCarousel = function() {
    if (!reviewsSlides || window.innerWidth > 768) return;
    currentReviewIndex = 0;
    cloneReviews();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (isReviewsSectionVisible()) updateReviewsSlider();
      });
    });
  };
})();


// ============================================
// Бесконечная карусель для block19_reviews_slider_wrapper (parentReviewsSlides) при 768px
// ============================================
(function() {
  let parentReviewsSlides = null;
  let parentReviewsSliderWrapper = null;
  let currentParentReviewIndex = 0;
  let isTransitioning = false;
  let isAnimating = false;
  const parentReviewGap = 13;
  const parentReviewWidth = 280;

  function getParentReviewWidth() {
    return parentReviewWidth;
  }

  function getParentReviewStep() {
    return getParentReviewWidth() + parentReviewGap;
  }

  function getTransitionDuration() {
    return '0.4s';
  }

  function getTransitionDurationMs() {
    return 400;
  }

  function getRealParentReviews() {
    if (!parentReviewsSlides) return [];
    // Получаем все реальные карточки (без клонов) в порядке DOM
    const allCards = Array.from(parentReviewsSlides.children).filter(child => {
      return child.classList.contains('block19_review_card') && 
             !child.classList.contains('block19-parent-review-card-clone');
    });
    // Фильтруем скрытые карточки (display: none) - для русской версии это 4-я карточка
    // Порядок сохраняется, так как мы используем children (который в порядке DOM)
    return allCards.filter(card => {
      const style = window.getComputedStyle(card);
      return style.display !== 'none';
    });
  }

  function cloneParentReviews() {
    if (!parentReviewsSlides || window.innerWidth > 768) {
      if (parentReviewsSlides) {
        const oldClones = parentReviewsSlides.querySelectorAll('.block19-parent-review-card-clone');
        oldClones.forEach(clone => clone.remove());
      }
      return;
    }

    const realParentReviews = getRealParentReviews();
    if (realParentReviews.length === 0) return;

    const oldClones = parentReviewsSlides.querySelectorAll('.block19-parent-review-card-clone');
    oldClones.forEach(clone => clone.remove());

    const fragmentBefore = document.createDocumentFragment();
    realParentReviews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('block19-parent-review-card-clone');
      fragmentBefore.appendChild(clone);
    });
    parentReviewsSlides.insertBefore(fragmentBefore, realParentReviews[0]);

    realParentReviews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('block19-parent-review-card-clone');
      parentReviewsSlides.appendChild(clone);
    });
  }

  function updateParentReviewsSlider() {
    if (!parentReviewsSlides || window.innerWidth > 768) return;

    const realParentReviews = getRealParentReviews();
    if (realParentReviews.length === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentParentReviewIndex < 0) {
      currentParentReviewIndex = 0;
    }
    if (currentParentReviewIndex >= realParentReviews.length) {
      currentParentReviewIndex = realParentReviews.length - 1;
    }

    const centerX = window.innerWidth / 2;
    const containerRect = parentReviewsSliderWrapper ? parentReviewsSliderWrapper.getBoundingClientRect() : parentReviewsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;

    const currentParentReviewWidth = getParentReviewWidth();
    const currentParentReviewStep = getParentReviewStep();
    const parentReviewCenterX = currentParentReviewWidth / 2;
    const realParentReviewIndexInDOM = realParentReviews.length + currentParentReviewIndex;
    const activeParentReviewLeftPosition = realParentReviewIndexInDOM * currentParentReviewStep;
    const activeParentReviewCenterPosition = activeParentReviewLeftPosition + parentReviewCenterX;

    const translateX = centerX - containerLeft - activeParentReviewCenterPosition;

    // Всегда устанавливаем transition для обычных переходов
    if (!isTransitioning) {
      parentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    parentReviewsSlides.style.transform = `translateX(${translateX}px)`;
  }

  function goToNextParentReview() {
    if (isAnimating || window.innerWidth > 768) return;

    const realParentReviews = getRealParentReviews();
    const realParentReviewsCount = realParentReviews.length;

    if (currentParentReviewIndex < realParentReviewsCount - 1) {
      isAnimating = true;
      currentParentReviewIndex++;
      updateParentReviewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const firstCloneIndex = realParentReviewsCount * 2;
      const currentParentReviewStep = getParentReviewStep();
      const containerRect = parentReviewsSliderWrapper ? parentReviewsSliderWrapper.getBoundingClientRect() : parentReviewsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentParentReviewWidth = getParentReviewWidth();
      const parentReviewCenterX = currentParentReviewWidth / 2;
      const activeParentReviewLeftPosition = firstCloneIndex * currentParentReviewStep;
      const activeParentReviewCenterPosition = activeParentReviewLeftPosition + parentReviewCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeParentReviewCenterPosition;

      parentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      parentReviewsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        parentReviewsSlides.style.transition = 'none';
        currentParentReviewIndex = 0;
        updateParentReviewsSlider();
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            parentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function goToPrevParentReview() {
    if (isAnimating || window.innerWidth > 768) return;

    const realParentReviews = getRealParentReviews();
    const realParentReviewsCount = realParentReviews.length;

    if (currentParentReviewIndex > 0) {
      isAnimating = true;
      currentParentReviewIndex--;
      updateParentReviewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const lastCloneIndex = realParentReviewsCount - 1;
      const currentParentReviewStep = getParentReviewStep();
      const containerRect = parentReviewsSliderWrapper ? parentReviewsSliderWrapper.getBoundingClientRect() : parentReviewsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentParentReviewWidth = getParentReviewWidth();
      const parentReviewCenterX = currentParentReviewWidth / 2;
      const activeParentReviewLeftPosition = lastCloneIndex * currentParentReviewStep;
      const activeParentReviewCenterPosition = activeParentReviewLeftPosition + parentReviewCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeParentReviewCenterPosition;

      parentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      parentReviewsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        parentReviewsSlides.style.transition = 'none';
        currentParentReviewIndex = realParentReviewsCount - 1;
        updateParentReviewsSlider();
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            parentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function getInitialTranslate() {
    const realParentReviews = getRealParentReviews();
    const containerRect = parentReviewsSliderWrapper ? parentReviewsSliderWrapper.getBoundingClientRect() : parentReviewsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;
    const centerX = window.innerWidth / 2;
    const currentParentReviewWidth = getParentReviewWidth();
    const currentParentReviewStep = getParentReviewStep();
    const parentReviewCenterX = currentParentReviewWidth / 2;
    const realParentReviewIndexInDOM = realParentReviews.length + currentParentReviewIndex;
    const activeParentReviewLeftPosition = realParentReviewIndexInDOM * currentParentReviewStep;
    const activeParentReviewCenterPosition = activeParentReviewLeftPosition + parentReviewCenterX;

    if (window.innerWidth <= 768 && currentParentReviewIndex === 0) {
      const viewportCenter = window.innerWidth / 2;
      return viewportCenter - containerLeft - activeParentReviewCenterPosition;
    } else {
      return centerX - containerLeft - activeParentReviewCenterPosition;
    }
  }

  function init() {
    if (window.innerWidth > 768) return;

    parentReviewsSlides = document.getElementById('parentReviewsSlides');
    if (!parentReviewsSlides) return;

    parentReviewsSliderWrapper = parentReviewsSlides.closest('.block19_reviews_slider_wrapper') || parentReviewsSlides.parentElement;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    cloneParentReviews();
    currentParentReviewIndex = 0; // Екатерина Белая - первый элемент (индекс 0)
    
    // Инициализация позиции
    const initialParentReviews = parentReviewsSlides.querySelectorAll('.block19_review_card');
    if (initialParentReviews.length > 0) {
      updateParentReviewsSlider();
    }

    // Привязываем кнопки стрелок напрямую к функциям карусели (мобиль)
    const parentPrevBtn = document.getElementById('parentReviewsPrev');
    const parentNextBtn = document.getElementById('parentReviewsNext');
    if (parentPrevBtn) parentPrevBtn.addEventListener('click', goToPrevParentReview);
    if (parentNextBtn) parentNextBtn.addEventListener('click', goToNextParentReview);

    parentReviewsSlides.addEventListener('mousedown', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      if (e.target.closest('button.block19_review_expand')) return;
      isDragging = true;
      startX = e.clientX;
      initialTranslate = getInitialTranslate();
      parentReviewsSlides.classList.add('dragging');
      e.preventDefault();
    });

    parentReviewsSlides.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      parentReviewsSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
    });

    parentReviewsSlides.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      parentReviewsSlides.classList.remove('dragging');

      const threshold = getParentReviewStep() / 6;
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevParentReview();
        } else {
          goToNextParentReview();
        }
      } else {
        updateParentReviewsSlider();
      }
      currentX = 0;
    });

    parentReviewsSlides.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        parentReviewsSlides.classList.remove('dragging');
        updateParentReviewsSlider();
        currentX = 0;
      }
    });

    parentReviewsSlides.addEventListener('touchstart', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      if (e.target.closest('button.block19_review_expand')) return;
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchInitialTranslate = getInitialTranslate();
      parentReviewsSlides.classList.add('dragging');
    });

    parentReviewsSlides.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;

      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }

      parentReviewsSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
    });

    parentReviewsSlides.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      parentReviewsSlides.classList.remove('dragging');

      const threshold = getParentReviewStep() / 6;
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevParentReview();
        } else {
          goToNextParentReview();
        }
      } else {
        updateParentReviewsSlider();
      }
      touchCurrentX = 0;
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth <= 768) {
          cloneParentReviews();
          updateParentReviewsSlider();
        } else {
          cloneParentReviews();
        }
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }

  window.addEventListener('load', () => {
    if (window.innerWidth <= 768) {
      currentParentReviewIndex = 0;
      updateParentReviewsSlider();
    }
  });

  // Экспортируем функции карусели для доступа из initParentReviewsSlider (стрелки)
  window.goToPrevParentReview = goToPrevParentReview;
  window.goToNextParentReview = goToNextParentReview;

  // Экспортируем функцию для обновления слайдера извне (например, из translatePage)
  window.updateParentReviewsSliderPosition = function() {
    if (window.innerWidth <= 768 && parentReviewsSlides) {
      // Получаем видимые карточки (getRealParentReviews() фильтрует скрытые с display: none)
      const realParentReviews = getRealParentReviews();
      
      if (realParentReviews.length > 0) {
        // Ограничиваем индекс в пределах доступных элементов
        if (currentParentReviewIndex < 0) {
          currentParentReviewIndex = 0;
        } else if (currentParentReviewIndex >= realParentReviews.length) {
          currentParentReviewIndex = realParentReviews.length - 1;
        }
        
        // Пересоздаем клоны на основе видимых карточек (внутри cloneParentReviews() клоны удаляются и создаются заново)
        cloneParentReviews();
        
        // Обновляем позицию слайдера
        updateParentReviewsSlider();
      }
    }
  };
})();

// ============================================
// Бесконечная карусель для block19_reviews_slider_wrapper (studentReviewsSlides) при 768px
// ============================================
(function() {
  let studentReviewsSlides = null;
  let studentReviewsSliderWrapper = null;
  let currentStudentReviewIndex = 0;
  let isTransitioning = false;
  let isAnimating = false;
  const studentReviewGap = 13;
  const studentReviewWidth = 280;

  function getStudentReviewWidth() {
    return studentReviewWidth;
  }

  function getStudentReviewStep() {
    return getStudentReviewWidth() + studentReviewGap;
  }

  function getTransitionDuration() {
    return '0.4s';
  }

  function getTransitionDurationMs() {
    return 400;
  }

  function getRealStudentReviews() {
    if (!studentReviewsSlides) return [];
    return Array.from(studentReviewsSlides.querySelectorAll('.block19_review_card:not(.block19-student-review-card-clone)'));
  }

  function cloneStudentReviews() {
    if (!studentReviewsSlides || window.innerWidth > 768) {
      if (studentReviewsSlides) {
        const oldClones = studentReviewsSlides.querySelectorAll('.block19-student-review-card-clone');
        oldClones.forEach(clone => clone.remove());
      }
      return;
    }

    const realStudentReviews = getRealStudentReviews();
    if (realStudentReviews.length === 0) return;

    const oldClones = studentReviewsSlides.querySelectorAll('.block19-student-review-card-clone');
    oldClones.forEach(clone => clone.remove());

    const fragmentBefore = document.createDocumentFragment();
    realStudentReviews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('block19-student-review-card-clone');
      fragmentBefore.appendChild(clone);
    });
    studentReviewsSlides.insertBefore(fragmentBefore, realStudentReviews[0]);

    realStudentReviews.forEach(card => {
      const clone = card.cloneNode(true);
      clone.classList.add('block19-student-review-card-clone');
      studentReviewsSlides.appendChild(clone);
    });
  }

  function updateStudentReviewsSlider() {
    if (!studentReviewsSlides || window.innerWidth > 768) return;

    const realStudentReviews = getRealStudentReviews();
    if (realStudentReviews.length === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentStudentReviewIndex < 0) {
      currentStudentReviewIndex = 0;
    }
    if (currentStudentReviewIndex >= realStudentReviews.length) {
      currentStudentReviewIndex = realStudentReviews.length - 1;
    }

    const centerX = window.innerWidth / 2;
    const containerRect = studentReviewsSliderWrapper ? studentReviewsSliderWrapper.getBoundingClientRect() : studentReviewsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;

    const currentStudentReviewWidth = getStudentReviewWidth();
    const currentStudentReviewStep = getStudentReviewStep();
    const studentReviewCenterX = currentStudentReviewWidth / 2;
    const realStudentReviewIndexInDOM = realStudentReviews.length + currentStudentReviewIndex;
    const activeStudentReviewLeftPosition = realStudentReviewIndexInDOM * currentStudentReviewStep;
    const activeStudentReviewCenterPosition = activeStudentReviewLeftPosition + studentReviewCenterX;

    const translateX = centerX - containerLeft - activeStudentReviewCenterPosition;

    // Всегда устанавливаем transition для обычных переходов
    if (!isTransitioning) {
      studentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    studentReviewsSlides.style.transform = `translateX(${translateX}px)`;
  }

  function goToNextStudentReview() {
    if (isAnimating || window.innerWidth > 768) return;

    const realStudentReviews = getRealStudentReviews();
    const realStudentReviewsCount = realStudentReviews.length;

    if (currentStudentReviewIndex < realStudentReviewsCount - 1) {
      isAnimating = true;
      currentStudentReviewIndex++;
      updateStudentReviewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const firstCloneIndex = realStudentReviewsCount * 2;
      const currentStudentReviewStep = getStudentReviewStep();
      const containerRect = studentReviewsSliderWrapper ? studentReviewsSliderWrapper.getBoundingClientRect() : studentReviewsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentStudentReviewWidth = getStudentReviewWidth();
      const studentReviewCenterX = currentStudentReviewWidth / 2;
      const activeStudentReviewLeftPosition = firstCloneIndex * currentStudentReviewStep;
      const activeStudentReviewCenterPosition = activeStudentReviewLeftPosition + studentReviewCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeStudentReviewCenterPosition;

      studentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      studentReviewsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        studentReviewsSlides.style.transition = 'none';
        currentStudentReviewIndex = 0;
        const realStudentReviewsCount = realStudentReviews.length;
        const currentStudentReviewStep = getStudentReviewStep();
        const containerRect = studentReviewsSliderWrapper ? studentReviewsSliderWrapper.getBoundingClientRect() : studentReviewsSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentStudentReviewWidth = getStudentReviewWidth();
        const studentReviewCenterX = currentStudentReviewWidth / 2;
        const realStudentReviewIndexInDOM = realStudentReviewsCount + currentStudentReviewIndex;
        const activeStudentReviewLeftPosition = realStudentReviewIndexInDOM * currentStudentReviewStep;
        const activeStudentReviewCenterPosition = activeStudentReviewLeftPosition + studentReviewCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeStudentReviewCenterPosition;
        studentReviewsSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            studentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function goToPrevStudentReview() {
    if (isAnimating || window.innerWidth > 768) return;

    const realStudentReviews = getRealStudentReviews();
    const realStudentReviewsCount = realStudentReviews.length;

    if (currentStudentReviewIndex > 0) {
      isAnimating = true;
      currentStudentReviewIndex--;
      updateStudentReviewsSlider();
      setTimeout(() => {
        isAnimating = false;
      }, getTransitionDurationMs());
    } else {
      if (isTransitioning || isAnimating) return;
      isTransitioning = true;
      isAnimating = true;

      const lastCloneIndex = realStudentReviewsCount - 1;
      const currentStudentReviewStep = getStudentReviewStep();
      const containerRect = studentReviewsSliderWrapper ? studentReviewsSliderWrapper.getBoundingClientRect() : studentReviewsSlides.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const currentStudentReviewWidth = getStudentReviewWidth();
      const studentReviewCenterX = currentStudentReviewWidth / 2;
      const activeStudentReviewLeftPosition = lastCloneIndex * currentStudentReviewStep;
      const activeStudentReviewCenterPosition = activeStudentReviewLeftPosition + studentReviewCenterX;
      const viewportCenter = window.innerWidth / 2;
      const translateX = viewportCenter - containerLeft - activeStudentReviewCenterPosition;

      studentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      studentReviewsSlides.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        studentReviewsSlides.style.transition = 'none';
        currentStudentReviewIndex = realStudentReviewsCount - 1;
        const currentStudentReviewStep = getStudentReviewStep();
        const containerRect = studentReviewsSliderWrapper ? studentReviewsSliderWrapper.getBoundingClientRect() : studentReviewsSlides.getBoundingClientRect();
        const containerLeft = containerRect.left;
        const currentStudentReviewWidth = getStudentReviewWidth();
        const studentReviewCenterX = currentStudentReviewWidth / 2;
        const realStudentReviewIndexInDOM = realStudentReviewsCount + currentStudentReviewIndex;
        const activeStudentReviewLeftPosition = realStudentReviewIndexInDOM * currentStudentReviewStep;
        const activeStudentReviewCenterPosition = activeStudentReviewLeftPosition + studentReviewCenterX;
        const viewportCenter = window.innerWidth / 2;
        const translateX = viewportCenter - containerLeft - activeStudentReviewCenterPosition;
        studentReviewsSlides.style.transform = `translateX(${translateX}px)`;
        
        requestAnimationFrame(() => {
          setTimeout(() => {
            isTransitioning = false;
            isAnimating = false;
            studentReviewsSlides.style.transition = `transform ${getTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getTransitionDurationMs());
    }
  }

  function getInitialTranslate() {
    const realStudentReviews = getRealStudentReviews();
    const containerRect = studentReviewsSliderWrapper ? studentReviewsSliderWrapper.getBoundingClientRect() : studentReviewsSlides.getBoundingClientRect();
    const containerLeft = containerRect.left;
    const centerX = window.innerWidth / 2;
    const currentStudentReviewWidth = getStudentReviewWidth();
    const currentStudentReviewStep = getStudentReviewStep();
    const studentReviewCenterX = currentStudentReviewWidth / 2;
    const realStudentReviewIndexInDOM = realStudentReviews.length + currentStudentReviewIndex;
    const activeStudentReviewLeftPosition = realStudentReviewIndexInDOM * currentStudentReviewStep;
    const activeStudentReviewCenterPosition = activeStudentReviewLeftPosition + studentReviewCenterX;

    if (window.innerWidth <= 768 && currentStudentReviewIndex === 0) {
      const viewportCenter = window.innerWidth / 2;
      return viewportCenter - containerLeft - activeStudentReviewCenterPosition;
    } else {
      return centerX - containerLeft - activeStudentReviewCenterPosition;
    }
  }

  function init() {
    if (window.innerWidth > 768) return;

    studentReviewsSlides = document.getElementById('studentReviewsSlides');
    if (!studentReviewsSlides) return;

    studentReviewsSliderWrapper = studentReviewsSlides.closest('.block19_reviews_slider_wrapper') || studentReviewsSlides.parentElement;

    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let initialTranslate = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let touchInitialTranslate = 0;

    cloneStudentReviews();
    currentStudentReviewIndex = 0; // Джессика - первый элемент (индекс 0)
    
    // Инициализация позиции
    const initialStudentReviews = studentReviewsSlides.querySelectorAll('.block19_review_card');
    if (initialStudentReviews.length > 0) {
      updateStudentReviewsSlider();
    }

    // Привязываем кнопки стрелок напрямую к функциям карусели
    const studentPrevBtn = document.getElementById('studentReviewsPrev');
    const studentNextBtn = document.getElementById('studentReviewsNext');
    if (studentPrevBtn) studentPrevBtn.addEventListener('click', goToPrevStudentReview);
    if (studentNextBtn) studentNextBtn.addEventListener('click', goToNextStudentReview);

    studentReviewsSlides.addEventListener('mousedown', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      if (e.target.closest('button.block19_review_expand')) return;
      isDragging = true;
      startX = e.clientX;
      initialTranslate = getInitialTranslate();
      studentReviewsSlides.classList.add('dragging');
      e.preventDefault();
    });

    studentReviewsSlides.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX - startX;
      studentReviewsSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
    });

    studentReviewsSlides.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      studentReviewsSlides.classList.remove('dragging');

      const threshold = getStudentReviewStep() / 6;
      if (Math.abs(currentX) > threshold) {
        if (currentX > 0) {
          goToPrevStudentReview();
        } else {
          goToNextStudentReview();
        }
      } else {
        updateStudentReviewsSlider();
      }
      currentX = 0;
    });

    studentReviewsSlides.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        studentReviewsSlides.classList.remove('dragging');
        updateStudentReviewsSlider();
        currentX = 0;
      }
    });

    studentReviewsSlides.addEventListener('touchstart', (e) => {
      if (isTransitioning || isAnimating || window.innerWidth > 768) return;
      if (e.target.closest('button.block19_review_expand')) return;
      isDragging = true;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchInitialTranslate = getInitialTranslate();
      studentReviewsSlides.classList.add('dragging');
    });

    studentReviewsSlides.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      touchCurrentX = e.touches[0].clientX - touchStartX;
      const touchCurrentY = e.touches[0].clientY - touchStartY;

      if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
        e.preventDefault();
      }

      studentReviewsSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
    });

    studentReviewsSlides.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      studentReviewsSlides.classList.remove('dragging');

      const threshold = getStudentReviewStep() / 6;
      if (Math.abs(touchCurrentX) > threshold) {
        if (touchCurrentX > 0) {
          goToPrevStudentReview();
        } else {
          goToNextStudentReview();
        }
      } else {
        updateStudentReviewsSlider();
      }
      touchCurrentX = 0;
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (window.innerWidth <= 768) {
          cloneStudentReviews();
          updateStudentReviewsSlider();
        } else {
          cloneStudentReviews();
        }
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(init, 300);
    });
  } else {
    setTimeout(init, 300);
  }

  window.addEventListener('load', () => {
    if (window.innerWidth <= 768) {
      currentStudentReviewIndex = 0;
      updateStudentReviewsSlider();
    }
  });

  // Экспортируем функции карусели для доступа из initStudentReviewsSlider (стрелки)
  window.goToPrevStudentReview = goToPrevStudentReview;
  window.goToNextStudentReview = goToNextStudentReview;

  // Экспортируем функцию для обновления слайдера извне (например, из translatePage)
  window.updateStudentReviewsSliderPosition = function() {
    if (window.innerWidth <= 768 && studentReviewsSlides) {
      // Получаем видимые карточки
      const realStudentReviews = getRealStudentReviews();
      
      if (realStudentReviews.length > 0) {
        // Сбрасываем индекс на 0 при переключении региона
        currentStudentReviewIndex = 0;
        
        // Пересоздаем клоны на основе видимых карточек
        cloneStudentReviews();
        
        // Обновляем позицию слайдера
        updateStudentReviewsSlider();
      }
    }
  };
})();
